<template>
  <div class="commentPageContainer">
    <!--Commenter-->
    <div v-if="isLoading">Loading card images...</div>
    <div v-else>
      <div class="cardImageHeaderContainer">
        <v-data-table
          :headers="cardHeaders"
          :items="multiverseCards"
          :footer-props="{
            'items-per-page-options': [],
            'items-per-page-text': null,
            'disable-items-per-page': true
            }"
          :options="printingSelectOptions"
          class="transparent"
        >
          <template v-slot:item="{ item }">
            <img :src="generateImageLink(item)" v-on:click="filterMultiverseIds(item)" class="cardimgselect">
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>
<script>
import store from '../store'

export default {
    data() {
        return {
            isLoading: true,
            multiverseCards: {},
            printingSelectOptions: {
              itemsPerPage: 5
            },
            cardHeaders: [
              {
                text: '',
                value: 'multiverseId'
              }
            ]
        }
    },
    async created () {
        this.unsubscribe = store.subscribe((mutation) => {
          if (mutation.type === 'updateMultiverseCards') {
            console.log('updating card scroll')
            this.multiverseCards = store.state.multiverseCards
            console.log(this.multiverseCards)
            this.isLoading = false
          }
        })

        /*try {
            const response = await axios.get(API_BASE_URL + '/cardheaders/scryfall/' + this.$route.query.card)
            this.multiverseCards = response.data.multiverseCards
            console.log(this.multiverseCards)
            this.isLoading = false
        } catch (e) {
            // handle the authentication error here
        }*/
    },

    watch: {
          search: function () {
            this.debounceFn()
          },
          model: function () {
            store.dispatch('selectCard', {"cardId": this.model.scryfallId})
          }
        },
    methods: {
      generateImageLink: function (card) {
        return 'https://api.scryfall.com/cards/' + card.setCode.toLowerCase() + '/' + card.number + '/en' + '/?format=image&version=png'
      },
      filterMultiverseIds: function (item) {
        store.dispatch('filterPosts', {'scryfallId': item.scryfallId, 'multiverseId': item.multiverseId}).then(() => {
        })
        store.dispatch('selectCard', {"cardId": item.scryfallId})
      }
    },
}
</script>
